<template>
  <div
    v-click-outside="closePopUps"
    class="tag-wrapper"
    @mouseleave="
      !clickForStablePopUp
        ? [
            (showTable = false),
            (brokerSuggestions = false),
            (showMergeTable = false)
          ]
        : ''
    "
    @click="
      [
        (showTable = true),
        (showMergeTable = false),
        (clickForStablePopUp = false)
      ]
    "
  >
    <span
      @click="[(showTable = true), (showMergeTable = false)]"
      class="label"
      :class="{
        'tag-new table-tag-content': client.is_new,
        'tag-active table-tag-content': !client.is_new
      }"
    >
      <span
        class="spacer"
        @click="
          // getGeoCode();
          getSuggestedBrokers(client)
        "
      >
        <span
          :class="{
            black:
              (client.not_interested_state && client.not_interested_state_id) ||
              (client.bad_number_state && client.bad_number_state_id),
            tagNameDesign: !client.is_new
          }"
          v-if="
            !client.leading &&
              !client.is_duplicate &&
              client.assignment_group !== null &&
              client.assignment_group.na_auto_removed === 1
          "
        >
          <span
            class="for-ni"
            v-if="client.not_interested_state && client.not_interested_state_id"
            >NI</span
          >

          <span
            class="min-size"
            v-else-if="client.bad_number_state && client.bad_number_state_id"
          >
            BN</span
          >
        </span>

        <span :class="{ forActive: !client.is_new }" v-if="!client.leading">
          <span
            class="onlyTagName"
            :class="{
              black:
                (client.not_interested_state &&
                  client.not_interested_state_id) ||
                (client.bad_number_state && client.bad_number_state_id),
              'min-size-nr':
                !client.is_new &&
                !client.not_interested_state_id &&
                !client.bad_number_state_id &&
                client.assignment_group &&
                client.assignment_group.assigned_to.id === 2
            }"
          >
            <span
              class="for-ni"
              v-if="
                client.not_interested_state && client.not_interested_state_id
              "
              >NI</span
            >
            <span
              v-else-if="
                !client.is_new &&
                  !client.not_interested_state_id &&
                  !client.bad_number_state_id &&
                  client.assignment_group &&
                  client.assignment_group.assigned_to.id === 2
              "
              >NR</span
            >

            <span
              v-else-if="client.bad_number_state && client.bad_number_state_id"
              >BN</span
            >
            <span class="min-size " v-else-if="!client.is_new">{{
              tagName
            }}</span>
            <span
              v-else-if="
                client.is_new &&
                  (client.is_duplicate ||
                    (client.assignment_group !== null &&
                      client.assignment_group.na_auto_removed === 1) ||
                    client.auto_na_remove_log_rec)
              "
            >
              <em
                @click.prevent="
                  $emit('origin', {
                    client_id: client.duplicate.client_id,
                    type: client.duplicate.group_id.type,
                    from: client.id,
                    origin: false
                  })
                "
                @mouseleave="
                  !clickForStablePopUp
                    ? [
                        (showTable = false),
                        (brokerSuggestions = false),
                        (showMergeTable = false)
                      ]
                    : ''
                "
                @mouseenter="
                  [
                    (showDuplicateTable = true),
                    (showTable = false),
                    (showMergeTable = false)
                  ]
                "
                v-if="
                  client.is_duplicate &&
                    checkPermissions(auth, [1, 2, 3, 4, 5, 12])
                "
                class="fa fa-copy origin-icon"
                ><span class="spacer"></span>
              </em>
              <em
                class="fas fa-phone-slash"
                v-if="
                  client.assignment_group !== null &&
                    client.assignment_group.na_auto_removed === 1
                "
                ><span class="spacer"></span
              ></em>
              <em
                @click="
                  [
                    (showAutoRemoveNaTable = true),
                    (showTable = false),
                    (showMergeTable = false)
                  ]
                "
                @mouseleave="
                  !clickForStablePopUp
                    ? [
                        (showTable = false),
                        (brokerSuggestions = false),
                        (showMergeTable = false)
                      ]
                    : ''
                "
                class="fas fa-phone-slash"
                v-if="
                  checkPermissions(auth, [1, 2, 3, 4, 5, 12]) &&
                    client.auto_na_remove_log_rec
                "
                ><span class="spacer"></span>
              </em>
            </span>
            <span class="min-size " v-else>{{ tagName }}</span>
          </span>

          <span class="onlyTagName ">{{
            formatDateForAct(client.created_at)
          }}</span>
          <span class="for-time" v-if="client.is_new"
            >{{ formatHourForAct(client.created_at) }}
          </span>
          <span v-if="!client.is_new">
            <em
              @click.prevent="
                $emit('origin', {
                  client_id: client.duplicate.client_id,
                  type: client.duplicate.group_id.type,
                  from: client.id,
                  origin: false
                })
              "
              @mouseleave="
                !clickForStablePopUp
                  ? [
                      (showTable = false),
                      (brokerSuggestions = false),
                      (showMergeTable = false)
                    ]
                  : ''
              "
              @mouseenter="
                [
                  (showDuplicateTable = true),
                  (showTable = false),
                  (showMergeTable = false)
                ]
              "
              v-if="
                client.is_duplicate &&
                  checkPermissions(auth, [1, 2, 3, 4, 5, 12])
              "
              class="fa fa-copy origin-icon"
              ><span class="spacer"></span>
            </em>
            <em
              class="fas fa-phone-slash"
              v-if="
                client.assignment_group !== null &&
                  client.assignment_group.na_auto_removed === 1
              "
              ><span class="spacer"></span
            ></em>
            <em
              @click="
                [
                  (showAutoRemoveNaTable = true),
                  (showTable = false),
                  (showMergeTable = false)
                ]
              "
              @mouseleave="
                !clickForStablePopUp
                  ? [
                      (showTable = false),
                      (brokerSuggestions = false),
                      (showMergeTable = false)
                    ]
                  : ''
              "
              class="fas fa-phone-slash"
              v-if="
                checkPermissions(auth, [1, 2, 3, 4, 5, 12]) &&
                  client.auto_na_remove_log_rec
              "
              ><span class="spacer"></span>
            </em>
          </span>
          <a
            v-if="client.ni.length > 0"
            @click.prevent="
              $emit('deleteFromAct', {
                type: 'UNTAG_NI',
                clientId: client.ni[0].client_id,
                tagIdNum: client.ni[0].id
              })
            "
            ><span v-if="showRemove" class="fas fa-times remove-tag-icon"></span
          ></a>
           <a
             v-if="client.assignment_group && client.assignment_group.assigned_to.id === 2"
             @click.prevent="
              $emit('deleteFromAct', {
                type: 'UNTAG_NR',
                clientId: client.assignment_group.client_id,
                tagIdNum: client.assignment_group.id
              })
            "
           ><span v-if="showRemove" class="fas fa-times remove-tag-icon"></span
           ></a>

          <a
            v-if="client.bn.length > 0"
            @click.prevent="
              $emit('deleteFromAct', {
                type: 'UNTAG_BN',
                clientId: client.bn[0].client_id,
                tagIdNum: client.bn[0].id
              })
            "
            ><span v-if="showRemove" class="fas fa-times remove-tag-icon"></span
          ></a>
          <span v-if="client.is_merged"
            ><span class="spacer"></span>
            <em
              @mouseenter="[(showMergeTable = true), (showTable = false)]"
              class="fas fa-link merge-icon "
            ></em>
          </span>
        </span>

        <!--//////////////////////////////////////YELLOW STAR//////////////////////////////////////-->
        <span v-if="client.leading > 0">
          <span>
            <!--//////////////////////////////////////NOT-INTERESTED//////////////////////////////////////-->
            <span
              class="onlyTagName black min-size"
              v-if="
                client.not_interested_state && client.not_interested_state_id
              "
              >{{ client.not_interested_state.short_name }}</span
            >
             <a
                 v-if="client.ni.length > 0"
                 @click.prevent="
              $emit('deleteFromAct', {
                type: 'UNTAG_NI',
                clientId: client.ni[0].client_id,
                tagIdNum: client.ni[0].id
              })
            "
             ><span v-if="showRemove" class="fas fa-times remove-tag-icon"></span
             ></a>
           <a
               v-if="client.assignment_group && client.assignment_group.assigned_to.id === 2"
               @click.prevent="
              $emit('deleteFromAct', {
                type: 'UNTAG_NR',
                clientId: client.assignment_group.client_id,
                tagIdNum: client.assignment_group.id
              })
            "
           ><span v-if="showRemove" class="fas fa-times remove-tag-icon"></span
           ></a>
            <!--//////////////////////////////////////BAD_NUMBER//////////////////////////////////////-->
            <span
              class="onlyTagName black min-size"
              v-if="client.bad_number_state && client.bad_number_state_id"
              >{{ client.bad_number_state.short_name }}</span
            >
            <span
              :class="{
                dnone:
                  (client.not_interested_state &&
                    client.not_interested_state_id) ||
                  (client.bad_number_state && client.bad_number_state_id)
              }"
              class="onlyTagName min-size"
              v-else
              >{{ tagName }}
              <i class="star-yellow fa fa-star" aria-hidden="true"></i>
            </span>

            <span class="onlyTagName">{{
              formatDateForAct(client.created_at)
            }}</span>
            <span class="for-time" v-if="client.is_new"
              >{{ formatHourForAct(client.created_at) }}
            </span>
          </span>
        </span>

        <!--//////////////////////////////////////BLACK STAR//////////////////////////////////////-->
        <span v-if="client.leading < 0">
          <span>
            <!--//////////////////////////////////////NOT-INTERESTED//////////////////////////////////////-->
            <span
              class="onlyTagName black min-size"
              v-if="
                client.not_interested_state && client.not_interested_state_id
              "
              >{{ client.not_interested_state.short_name }}</span
            >
            <!--//////////////////////////////////////BAD-NUMBER//////////////////////////////////////-->
            <span
              class="onlyTagName black min-size"
              v-if="client.bad_number_state && client.bad_number_state_id"
              >{{ client.bad_number_state.short_name }}</span
            >
            <span
              :class="{
                dnone:
                  (client.not_interested_state &&
                    client.not_interested_state_id) ||
                  (client.bad_number_state && client.bad_number_state_id)
              }"
              class="onlyTagName min-size"
              v-else
              >{{ tagName }}
              <i class="star-black fa fa-star" aria-hidden="true"></i>
            </span>

            <span class="onlyTagName">{{
              formatDateForAct(client.created_at)
            }}</span>
            <span class="for-time" v-if="client.is_new"
              >{{ formatHourForAct(client.created_at) }}
            </span>
          </span>
        </span>

        <!--//////////////////////////////////////ACTIVE//////////////////////////////////////-->
        <span v-if="!client.is_new" class="tag-time">
          <!--//////////////////////////////////////DUP + NI\BN  //////////////////////////////////////-->
          <!--          <span-->
          <!--            v-if="-->
          <!--              client.is_duplicate &&-->
          <!--                ((client.not_interested_state &&-->
          <!--                  client.not_interested_state_id) ||-->
          <!--                  (client.bad_number_state && client.bad_number_state_id))-->
          <!--            "-->
          <!--          >-->
          <!--//////////////////////////////////////NOT-INTERESTED//////////////////////////////////////-->

          <!--            <span-->
          <!--                class="onlyTagName black"-->
          <!--              v-if="-->
          <!--                client.not_interested_state && client.not_interested_state_id-->
          <!--              "-->
          <!--              >NI</span>-->

          <!--//////////////////////////////////////BAD_NUMBER//////////////////////////////////////-->

          <!--            <span   class="onlyTagName black" v-if="client.bad_number_state && client.bad_number_state_id"-->
          <!--              >BN</span-->
          <!--            >-->
          <!--          </span>-->
          <!--//////////////////////////////////////ASSIGMENT-GROUP//////////////////////////////////////-->
          <span
            v-if="
              // !client.not_interested_state_id &&
              //   !client.bad_number_state_id &&
              client.assignment_group &&
                client.assignment_group.assigned_to.id === 2
            "
          ></span>
          <!--          <span v-if="!client.is_duplicate">-->
          <!--            {{ formatDate(client.created_at) }}-->
          <!--          </span>-->
        </span>

        <!--        -->
        <!--        <span-->
        <!--          v-if="-->
        <!--            client.is_new &&-->
        <!--              client.assignment_group !== null &&-->
        <!--              client.assignment_group.na_auto_removed === 1-->
        <!--          "-->
        <!--          >{{ formatDateForAct(client.created_at) }}</span-->
        <!--        >-->

        <!--        <span-->
        <!--          v-if="-->
        <!--            client.is_new &&-->
        <!--              client.assignment_group !== null &&-->
        <!--              client.assignment_group.na_auto_removed !== 1-->
        <!--          "-->
        <!--          >{{ formatDate(client.created_at) }}</span-->
        <!--        >-->

        <!--        <span v-else-if="client.is_new && client.assignment_group === null">{{-->
        <!--          formatDate(client.created_at)-->
        <!--        }}</span>-->
      </span>
      <!--      <span style="margin-left: 3px;">{{-->
      <!--        formatDateForAct(client.created_at)-->
      <!--      }}</span>-->
      <!--//////////////////////////////////////POP-UPS//////////////////////////////////////-->
    </span>

    <div
      v-if="showTable"
      class="tag-table pop-up-for-tags"
      @mouseleave="
        !clickForStablePopUp
          ? [
              (showTable = false),
              (brokerSuggestions = false),
              (showMergeTable = false)
            ]
          : ''
      "
    >
      <div
        class="table-responsive"
        @mouseleave="
          !clickForStablePopUp
            ? [
                (showTable = false),
                (brokerSuggestions = false),
                (showMergeTable = false)
              ]
            : ''
        "
      >
        <table class="table " cellpadding="0" cellspacing="0">
          <thead>
            <tr>
              <th>Date</th>
              <th>Time</th>
              <th>Agent</th>
              <th>VM</th>
              <th></th>
              <th></th>
              <th v-if="client.not_interested_state">NI</th>
              <th
                v-if="
                  client.not_interested_state &&
                    client.not_interested_state_id &&
                    client.hasOwnProperty('na') &&
                    client.na.length > 0
                "
              >
                NA-NI
              </th>
              <th
                v-if="
                  client.not_interested_state &&
                    client.not_interested_state_id &&
                    client.hasOwnProperty('scheduled_calls') &&
                    client.scheduled_calls.length > 0
                "
              >
                SC-NI
              </th>
              <th v-if="client.bad_number_state && client.bad_number_state_id">
                BN
              </th>
              <th>
                <i
                  class="fa fa-times"
                  aria-hidden="true"
                  @mouseenter="
                    [
                      (showTable = false),
                      (brokerSuggestions = false),
                      (showMergeTable = false)
                    ]
                  "
                ></i>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td
                :class="{
                  inBetweenSelectedCalDates: checkSelectedCalDates(client)
                }"
              >
                {{ formatDate(client.created_at) }}
              </td>
              <td
                :class="{
                  inBetweenSelectedCalDates: checkSelectedCalDates(client)
                }"
              >
                {{ client.created_at | shortTime }}
              </td>
              <td>{{ "viki" }}</td>
              <td></td>
              <td></td>
              <td>Rating</td>
              <td
                v-if="
                  client.not_interested_state && client.not_interested_state_id
                "
              >
                {{ client.not_interested_state.name }}
              </td>

              <!--              CALCULATE NA TIME TO NI TIME-->
              <th
                v-if="
                  client.not_interested_state &&
                    client.not_interested_state_id &&
                    client.hasOwnProperty('na') &&
                    client.na.length > 0
                "
              >
                {{
                  getDiffByTimes(
                    client.na[client.na.length - 1].created_at,
                    client.ni[client.ni.length - 1].created_at
                  ).toUpperCase()
                }}
              </th>
              <!--              CALCULATE SC TIME TO NI TIME-->

              <th
                v-if="
                  client.not_interested_state &&
                    client.not_interested_state_id &&
                    client.hasOwnProperty('scheduled_calls') &&
                    client.scheduled_calls.length > 0
                "
              >
                {{
                  getDiffByTimes(
                    client.scheduled_calls[client.scheduled_calls.length - 1]
                      .scheduled_on,
                    client.ni[client.ni.length - 1].created_at
                  ).toUpperCase()
                }}
              </th>

              <td v-if="client.bad_number_state">
                {{ client.bad_number_state.name }}
              </td>
            </tr>
            <tr>
              <td v-if="client.keyword">{{ client.keyword }}</td>
              <td v-if="client.campaign_aaid">{{ client.campaign_aaid }}</td>
              <td v-if="client.device">{{ client.device }}</td>
              <td v-if="client.lead_loc">{{ client.lead_loc }}</td>
              <td v-if="client.click_on_site">{{ client.click_on_site }}</td>
              <td
                class="forNumOutOfName"
                v-if="
                  client.leading < 0 && checkPermissions(auth, [1, 2, 3, 12])
                "
              >
                {{ client.leading }}
              </td>
              <td
                class="forNumOutOfName"
                v-if="
                  client.leading > 0 && checkPermissions(auth, [1, 2, 3, 12])
                "
              >
                {{ client.leading }}
              </td>
              <td></td>
            </tr>
          </tbody>
          <thead v-if="brokerSuggestions">
            <tr>
              <th>Suggested Broker options</th>
            </tr>
            <!--          </thead>-->
            <!--          <tbody v-if="brokerSuggestions">-->
            <!--            <tr>-->
            <!--              Suggested Broker options-->
            <!--            </tr>-->
            <tr v-for="broker in suggestedBrokers" :key="broker">
              <td
                v-if="
                  FilterNonActiveBrokers(dictionaries.general.brokers).find(
                    item => item.id == broker.id
                  ) !== undefined
                "
              >
                {{
                  FilterNonActiveBrokers(dictionaries.general.brokers).find(
                    item => item.id == broker.id
                  ).name
                }}
                <span v-if="checkPermissions(auth, [1, 2, 3, 12])"
                  >| {{ broker.total }}</span
                >
              </td>
              <td
                v-if="
                  FilterNonActiveBrokers(dictionaries.general.brokers).find(
                    item => item.id == broker.id
                  ) !== undefined && broker['methods']
                "
                v-for="method in broker['methods']"
                :key="method"
              >
                {{
                  dictionaries.activity.deposit_methods.find(
                    item => item.id == method.id
                  ).method
                }}
              </td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
          </thead>
        </table>
      </div>
    </div>

    <div v-if="showDuplicateTable" class="tag-table pop-up-for-tags">
      <div
        class="table-responsive"
        @mouseleave="
          !clickForStablePopUp
            ? [
                (showTable = false),
                (brokerSuggestions = false),
                (showMergeTable = false),
                (showDuplicateTable = false)
              ]
            : ''
        "
      >
        <table class="table ">
          <tbody>
            <tr>
              <td>{{ formatDate(client.duplicate.created_at) }}</td>
              <td>
                <strong v-if="client.duplicate.original_reg !== null">{{
                  formatDate(client.duplicate.original_reg)
                }}</strong>

                <strong v-else>{{
                  formatDate(client.duplicate.copied_client.created_at)
                }}</strong>
              </td>
              <td>{{ client.duplicate.created_at | shortTime }}</td>
              <td>{{ client.duplicate.user.full_name }}</td>
              <td>{{ client.duplicate.group_id.type }}</td>
              <td>{{ client.duplicate.prev_user.full_name }}</td>
              <td>{{ client.duplicate.client_id }}</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <th>
                <i
                  class="fa fa-times"
                  aria-hidden="true"
                  @mouseenter="
                    [
                      (showTable = false),
                      (brokerSuggestions = false),
                      (showMergeTable = false),
                      (showDuplicateTable = false)
                    ]
                  "
                ></i>
              </th>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div
      v-if="client.duplicates.length > 0 && showDuplicatesTable"
      class="tag-table pop-up-for-tags"
    >
      <div
        class="table-responsive"
        @mouseleave="
          !clickForStablePopUp
            ? [
                (showTable = false),
                (brokerSuggestions = false),
                (showMergeTable = false)
              ]
            : ''
        "
      >
        <table class="table ">
          <tbody>
            <tr v-for="dup in client.duplicates" :key="dup.id">
              <td>{{ formatDate(dup.created_at) }}</td>
              <td>{{ dup.created_at | shortTime }}</td>
              <td>{{ dup.user.full_name }}</td>
              <td>{{ dup.group_id.type }}</td>
              <td>
                <a
                  class="dup-link"
                  @click.prevent="
                    $emit('origin', {
                      client_id: dup.duplicate_id,
                      type: dup.new_group_id.type,
                      from: client.id,
                      origin: true
                    })
                  "
                  >{{ dup.duplicate_id }}</a
                >
              </td>

              <td>{{ dup.assigned_to.full_name }}</td>
              <td>{{ dup.new_group_id.type }}</td>
              <td></td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div v-if="showRepopulationTable" class="tag-table pop-up-for-tags">
      <div
        class="table-responsive"
        @mouseleave="
          !clickForStablePopUp
            ? [
                (showTable = false),
                (brokerSuggestions = false),
                (showMergeTable = false)
              ]
            : ''
        "
      >
        <table class="table ">
          <tbody>
            <tr v-for="item in client.client_repopulation" :key="item.id">
              <td>{{ formatDate(item.created_at) }}</td>
              <td>{{ item.created_at | shortTime }}</td>
              <td>{{ item.from_group.type }}</td>
              <td>{{ item.user.full_name }}</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div
      v-if="showMergeTable && client.merged_to.user"
      class="tag-table pop-up-for-tags"
    >
      <div
        class="table-responsive"
        @mouseleave="
          !clickForStablePopUp
            ? [
                (showTable = false),
                (brokerSuggestions = false),
                (showMergeTable = false)
              ]
            : ''
        "
      >
        <table class="table ">
          <tbody>
            <tr>
              <td>{{ formatDate(client.merged_to.created_at) }}</td>
              <td>{{ client.merged_to.created_at | shortTime }}</td>
              <td>{{ client.merged_to.user.full_name }}</td>
              <td>
                <a
                  class="origin-icon"
                  @click="$emit('merged', client.merged_to.client_id)"
                >
                  {{ client.merged_to.client_id }}</a
                >
              </td>
              <td>
                <span
                  v-if="client.merged_to.user.comments"
                  v-tooltip.bottom="{ content: client.merged_to.user.comments }"
                  >{{ client.merged_to.user.comments | truncate(160) }}</span
                >
              </td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div v-if="showAutoRemoveNaTable" class="tag-table pop-up-for-tags ">
      <div
        class="table-responsive"
        @mouseleave="
          !clickForStablePopUp
            ? [
                (showTable = false),
                (brokerSuggestions = false),
                (showMergeTable = false)
              ]
            : ''
        "
      >
        <table class="table ">
          <tbody>
            <tr>
              <td>
                {{ formatDate(client.auto_na_remove_log_rec.created_at) }}
              </td>
              <td>
                {{ client.auto_na_remove_log_rec.created_at | shortTime }}
              </td>
              <td>{{ client.auto_na_remove_log_rec.user.full_name }}</td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import {mapGetters, mapState} from "vuex";
import apiClientCreator from "../../../../../../helpers/api/request";
import BrokersActiveScope from "../../mixins/BrokersActiveScope";
import getDiffInTime from "../../../../../../mixins/util/getDiffInTime";
import ClickOutside from "v-click-outside";

export default {
  name: "is-new-or-active",
  mixins: [BrokersActiveScope, getDiffInTime],
  props: {
    client: {
      type: Object,
      required: true
    },
    showRemove: {
      type: Boolean,
      required: true
    }
  },
  directives: {
    clickOutside: ClickOutside.directive
  },
  data() {
    return {
      showTable: false,
      showDuplicateTable: false,
      showDuplicatesTable: false,
      showRepopulationTable: false,
      showAutoRemoveNaTable: false,
      showMergeTable: false,
      cityName: null,
      brokerSuggestions: false,
      suggestedBrokers: [],
      clickForStablePopUp: false
    };
  },

  computed: {
    ...mapState("user", ["auth"]),
    ...mapGetters("user", ["isLogged"]),
    ...mapState("clients", [ "dictionaries", "generalQueryObject"]),
    tagName() {
      if (this.client.is_new) {
        return "N";
      } else {
        // if (!this.client.active) {
        //   return "N/AC";
        // }
        return "AC";
      }
    }
  },
  created() {
    window.addEventListener("click", this.closeEdit);
  },
  watch: {},
  mounted() {

  },
  methods: {
    closePopUps() {
      this.clickForStablePopUp = false;
    },
    checkSelectedCalDates(acDit) {
      let acIn = moment(acDit.created_at);
      let start = moment(this.generalQueryObject.registered_on_from).startOf(
        "day"
      );
      let to = moment(this.generalQueryObject.registered_on_to).endOf("day");
      // if (acIn.isBetween(start, to)) {
      //   return true;
      // } else {
      //   return false;
      // }
      return acIn.isBetween(start, to);
    },
    // filterMain() {
    //   this.$store.commit("clients/setFilterToMain", {
    //     title: "nw",
    //     type: true
    //   });
    // },
    async getGeoCode() {
      // this.$store.commit("clients/setLoading", true);
      let locPhisMs;
      if (this.client.loc_physical_ms === null) {
        locPhisMs = "";
      } else {
        const reqCriteria = apiClientCreator(
          `utils/client/criteria/${this.client.loc_physical_ms}`
        );
        reqCriteria.get("").then(locPhisMs => {
          if (locPhisMs.data) {
            this.cityName = locPhisMs.data[0];
            this.showCityPopup = true;
          }
          // this.$store.commit("clients/setLoading", false);
        });
      }
    },
    async getSuggestedBrokers(client) {
      const res = await apiClientCreator(
        `reports/brokers/performance/reports/latest`
      ).get("");
      let countryData = res.data.find(item => {
        return item.id == client["country_id"];
      });
      if (countryData) {
        this.suggestedBrokers = countryData["brokers"];
        this.brokerSuggestions = true;
      }
    },
    checkPermissions(user, permitted) {
      return permitted.some(role => role === user.user.role);
    },
    formatDate(date) {
      return moment(String(date)).format("HH:mm DD/MM/YY");
    },
    formatDateForAct(date) {
      return moment(String(date)).format("DD/MM/YY");
    },
    formatHourForAct(date) {
      return moment(String(date)).format("HH:mm");
    },
    closeEdit(e) {
      if (!this.$el.contains(e.target)) {
        this.showDuplicatesTable = false;
        this.showMergeTable = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.tag-wrapper {
  cursor: pointer;
  display: inline-flex;
  position: relative;
  font-family: "Montserrat" !important;
}

.hoverTable {
}

.tag-new {
  background-color: #1ac51a;
  /*color: white;*/
  /*margin: 2px;*/
  /*padding: 3px;*/
  /*cursor: pointer;*/
  /*font-weight: 500;*/
  /*line-height: 2;*/
  /*animation: flash linear 1s;*/
  /*min-width: 148px !important;*/
  /*max-width: 148px !important;*/
}

@keyframes flash {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 3;
  }
}
.tag-active .tag-table .table-responsive .table {
  margin-bottom: unset !important;
}
.tag-active {
  background-color: #1bc51b;
  /*min-width: 152px !important;*/
  /*max-width: 157px !important;*/
  /*font-size: 12px;*/
  /*color: white;*/
  /*margin: 2px;*/
  /*padding: 3px;*/
  /*cursor: pointer;*/
  /*font-weight: 500;*/
  /*line-height: 2;*/
  /*
            line-height: 2;
          */
  animation: flash linear 1s;
}

@keyframes flash {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 3;
  }
}

.tag-table {
  bottom: 39px;
  border: solid 1px #008b00;
  margin-bottom: 1px !important;
  max-height: 267px;
  overflow-y: scroll;
}

.table-responsive {
  /*<!--margin-bottom: -18px;-->*/
  border-radius: 5px;
}
table {
  margin-bottom: unset !important;
  border-radius: 5px !important;
}

.tag-time {
  font-size: 11.3px;
  cursor: pointer;
}

.origin-icon {
  cursor: pointer;
}
.origin-icon-down-arrow {
  cursor: pointer;
  padding-left: 1.5px;
  margin-right: 1px;
}

.merge-icon {
  cursor: pointer;
  padding-right: 2px;
}

.dup-link {
  cursor: pointer;
  font-weight: 600;
}

.spacer {
  margin-right: unset !important;
  margin-left: 2px !important;
}
.star-yellow {
  /*  top: -6px;
  left: -3px;
  font-size: 75%;*/
  position: relative;
  color: yellow;
}
.star-black {
  color: black;
  /*top: -6px;
  left: -3px;
  font-size: 75%;*/
  position: relative;
}
.label {
  padding: 4px 2px 4px 2px;
  font-size: 12px;
}
.min-size {
  //border: 1px solid white;
  border-radius: 5px;
  padding: 3px;
}
.for-ni {
  padding: 3px;
}
.onlyTagName {
  /*padding-left: 2px;*/
  /*border: 1px solid white;*/
  /*border-radius: 5px;*/
  /*padding: 2px;*/
  /*margin-right: 3px;*/
  /*font-size: 11px !important;*/
  /*margin-left: 1px;*/
  //border: 1px solid white;
  border-radius: 5px;
  padding: 3px;
  /*margin-right: 3px;*/
  font-size: 11px !important;
  margin-right: 3px;
}
.onlyTagName:hover {
  font-size: 12.3px !important;
}
.tagNameDesign:hover {
  font-size: 11px !important;
}
.tagNameDesign {
  margin-left: -5px !important;
  margin-right: 3px;
  //border: unset !important;
}

.fa-phone-slash {
  cursor: pointer;
}

.forNumOutOfName {
  font-weight: 100;
  padding-right: 4px;
}
.pop-up-for-tags {
  padding-top: 3px;
}
/*.pop-up-for-tags {*/
/*  font-size: 10.5px !important;*/
/*}*/
.forActive {
  font-size: 9px !important;
}
.forActive i {
  vertical-align: text-top;
}
tr:not(:last-child) td {
  padding-top: 1px;
}
tr:not(:first-child) td {
  padding-top: 1px;
}

.table > thead > tr > th,
.table > tbody > tr > th,
.table > tfoot > tr > th,
.table > thead > tr > td,
.table > tbody > tr > td,
.table > tfoot > tr > td {
  line-height: 1.1 !important;
}
.inBetweenSelectedCalDates {
  /*background: lightgrey;*/
  /*border: 1px solid white !important;*/
  color: blue;
}
tbody > tr:nth-of-type(odd) {
  background-color: #7a7a7a0d;
}
/* width */
::-webkit-scrollbar {
  width: 3px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #808080;
  border-radius: 10px;
}
.black {
  background-color: black;
  //border: 1px solid black;
  //padding: 2px;
  border-radius: 5px;
}
.min-size-nr {
  background-color: red;
  //border: 1px solid red;
  border-radius: 5px;
  font-size: 11px !important;
  padding: 3px;
}
.remove-tag-icon {
  /*color: white;*/
  /*cursor: pointer;*/
  /*margin-left: 5px;*/
  /*color: white;*/
  /*cursor: pointer;*/
  /*margin-left: 0px;*/
  /*position: absolute;*/
  /*left: 11px;*/
  /*font-size: 17px;*/
  /*padding-top: 2px;*/
  /*padding-bottom: 2px;*/
  /*padding-left: 6px;*/
  /*padding-right: 6px;*/
  /*border: 1px solid black;*/
  /*border-radius: 5px;*/
  /*top: 6px;*/
  /*background: black;*/
  /*color: white;*/
  /*cursor: pointer;*/
  /*margin-left: 5px;*/
  color: white;
  cursor: pointer;
  margin-left: 0px;
  position: absolute;
  left: 8px;
  font-size: 16px;
  padding-top: 2px;
  padding-bottom: 2px;
  padding-left: 6px;
  padding-right: 6px;
  //border: 1px solid black;
  border-radius: 5px;
  top: 6px;
  background: black;
}
.remove-tag-icon:hover {
  color: white;
  background: black;
}
span.tagNameDesignM.black {
  border-radius: 5px;
  padding: 4px;
  margin-right: 3px;
  font-size: 11.5px !important;
  margin-left: -2px;
}
//.onlyTagName .min-size {
//  padding: 1.5px;
//}
.dnone {
  display: none;
}
.for-time {
  padding-right: -11px;
  margin-left: -3px;
  margin-right: 1px;
}
</style>
